import { grey, red } from "@mui/material/colors";

const styles = {
  activeButton: {
    width: "120px",
    borderRadius: "0.5rem",
    height: "38px",
    backgroundColor: red["A400"],
    color: "white",
    "&:hover": {
      backgroundColor: red["A700"],
    },
  },
  inactiveButton: {
    width: "120px",
    borderRadius: "0.5rem",
    height: "38px",
    backgroundColor: grey[500],
    color: grey[300],
  },
  cancelButton: {
    width: "120px",
    borderRadius: "0.5rem",
    height: "38px",
    color: red["A400"],
    backgroundColor: red["50"],
  },
  circularProgress: {
    color: "white",
  },
  gridContainer: {
    marginTop: 2,
  },
  mapContainer: {
    height: "60vh",
    width: "100%",
  },
  title: {
    textAlign: "center",
    fontWeight: "bold",
    color: grey[800],
    marginBottom: 2,
  },
  dialog: {
    borderRadius: "16px",
    width: "100%",
    height: "90%",
  },
  mainContainer: {
    padding: { xs: 2, sm: 3, md: 4 },
  },
};

export default styles;
